import PageHeader from "@/app/shared/page-header";
import CreateEditRole from "@/app/shared/roles-permissions/create-role";

export default function CreateRolePage( ) {
    const pageHeader = {
        title: "User Management",
        breadcrumb: [
            {
                href: "/",
                name: "Home",
            },
            {
                name: "User Management",
            },
            {
                name: "Create Role",
            }
        ],
    };
   
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            ></PageHeader>
            <CreateEditRole isEdit={false} />
        </>
    );
}
